module.exports = __webpack_public_path__ + "img/prev.087df18d.png";